// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"15779b26","455":"e21dedf0","977":"0a197c15"}[chunkId] + ".chunk.js";
};